import { QueryKey } from 'constants/reactQuery';

export const profileBlockQueryKey = {
  profileBlocks: [QueryKey.Profile, QueryKey.Block] as const,
  profileBlock: (id: number) => [...profileBlockQueryKey.profileBlocks, id] as const,
};
